import { IState, IPostsState } from 'types/redux'

export const getPostsState = ({ posts }: IState): IPostsState => posts

export const getPostItems = ({ posts }: IState): Array<any> => posts.items

export const getPostsLoading = ({ posts }: IState): boolean => posts.isLoading

export const getCreatedPostId = ({ posts }: IState): number | null => posts.createdPostId